import React from 'react';
import { Box, Stack, TextField, Typography } from '@mui/material';

const StructuredStep = ({ config, response = {}, onChange, disabled }) => {
  const answers = response.answers || {};

  const handleChange = (index, value) => {
    onChange({ ...response, answers: { ...answers, [index]: value } });
  };

  return (
    <Stack spacing={2.5}>
      {config.prompts.map((prompt, i) => (
        <Box key={i}>
          <Typography variant="body2" fontWeight={600} mb={0.75} color="text.primary">
            {i + 1}. {prompt}
          </Typography>
          <TextField
            value={answers[i] || ''}
            onChange={(e) => handleChange(i, e.target.value)}
            placeholder="Your answer…"
            multiline
            minRows={3}
            fullWidth
            disabled={disabled}
            variant="outlined"
            size="small"
          />
        </Box>
      ))}
    </Stack>
  );
};

export default StructuredStep;
